export const POLLING_INTERVAL_SECONDS = 1;
export const POLLING_TIMEOUT_SECONDS = 3600;
